import { getStore } from './store/store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isMsalFlowEnabled } from 'owa-msaljs/lib/isMsalFlowEnabled';

export function showAuthInfoBar(): boolean {
    return (
        getStore().isSigninRequired &&
        isFeatureEnabled('auth-msaljs-reauthenticate-banner') &&
        isMsalFlowEnabled()
    );
}
